<template>
  <b-row>
    <b-col sm="12" md="12" lg="4">
      <b-pagination
        v-model="compCurrentPage"
        :total-rows="compRowCount"
        :per-page="compPerPage"
        first-number
        last-number
        aria-controls="table-tabela-proceda"
      />
    </b-col>
    <b-col sm="12" md="12" lg="4">
      <label for="perPageSelect">
        {{ getPerPageSelectLabel }}
      </label>
    </b-col>
    <b-col sm="12" md="12" lg="4">
      <b-row>
        <b-col lg="8" class="text-md-left text-lg-right">
          <label for="perPageSelect"> Registros por página: </label>
        </b-col>
        <b-col>
          <b-form-select
            v-model="compPerPage"
            id="perPageSelect"
            size="sm"
            :options="compPageOptions"
          />
        </b-col>
      </b-row>
      <!-- <b-form-group
        label-for="perPageSelect"
        label="Registros por página"
        label-class="label-top"
        label-cols-lg="8"
        label-align-lg="right"
        label-align-md="left"
      >
        <b-form-select
          v-model="compPerPage"
          id="perPageSelect"
          size="sm"
          :options="compPageOptions"
        />
      </b-form-group> -->
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    currentPage: Number,
    pageOptions: Array,
    perPage: Number,
    rowCount: Number,
  },
  computed: {
    getPaginationFrom() {
      return this.perPage * (this.currentPage - 1) + 1;
    },
    getPaginationTo() {
      let to = this.getPaginationFrom - 1 + this.perPage;
      if (to > this.rowCount) return this.rowCount;
      return to;
    },
    getPerPageSelectLabel() {
      return `Exibindo ${this.getPaginationFrom} até ${this.getPaginationTo} de um total de ${this.rowCount}`;
    },
    compPerPage: {
      get: function () {
        return this.perPage;
      },
      set: function (value) {
        this.$emit("update:perPage", parseInt(value));
      },
    },
    compCurrentPage: {
      get: function () {
        return this.currentPage;
      },
      set: function (value) {
        this.$emit("update:currentPage", parseInt(value));
      },
    },
    compRowCount: {
      get: function () {
        return this.rowCount;
      },
      set: function (value) {
        this.$emit("update:rowCount", parseInt(value));
      },
    },
    compPageOptions: {
      get: function () {
        return this.pageOptions;
      },
      set: function (value) {
        this.$emit("update:pageOptions", parseInt(value));
      },
    },
  },
};
</script>

<style scoped>
.label-top {
  padding-top: 1px !important;
}
</style>